import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { router } from './routes';
import { useAuthStore } from './store/authStore';
import { useRichiesteCountStore } from './store/richiesteStore';
import { useOrdiniCountStore } from './store/ordiniStore';
import { startSessionManager, stopSessionManager } from './lib/sessionManager';

export default function App() {
  const { t } = useTranslation();
  const { isAuthenticated, user, isBootstrapped, bootstrap } = useAuthStore();
  const refetchCount = useRichiesteCountStore((s) => s.refetch);
  const refetchOrdiniCount = useOrdiniCountStore((s) => s.refetch);

  // bootstrap solo se c'è un token salvato ma user non ancora caricato
  useEffect(() => {
    if (isAuthenticated && !user) {
      bootstrap();
    }
  }, [isAuthenticated, user, bootstrap]);

  // aggiorna i contatori ogni volta che l'utente viene autenticato
  useEffect(() => {
    if (user) {
      refetchCount();
      refetchOrdiniCount();
    }
  }, [user, refetchCount, refetchOrdiniCount]);

  // sliding expiration: avvia il rinnovo proattivo finché autenticato, ferma al logout
  useEffect(() => {
    if (isAuthenticated) {
      startSessionManager();
      return () => stopSessionManager();
    }
    return undefined;
  }, [isAuthenticated]);

  // attende la verifica del token prima di mostrare il router
  if (!isBootstrapped) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <span>{t('common.caricamento_puntini')}</span>
      </div>
    );
  }

  return <RouterProvider router={router} />;
}
